import { useState } from "react";
import { Smartphone } from "lucide-react";
import vectorProfile from "../../assets/images/vectorProfile.svg";
import dummyUser from "../../assets/images/dummyUser.svg";
import useImageUrl from "../../CustomHooks/useImageUrl";
import { mapRoles } from "../../utils/roles";
import MobileVerify from "../../components/auth/MobileVerify";

const ProfileHeader = ({ userData }) => {
  const [openVerify, setOpenVerify] = useState(false);
  const roles = localStorage.getItem("roles");
  const rolesList = roles ? roles.split(",").map((p) => p.trim()) : [];
  const { getImageUrl } = useImageUrl();
  const roleValues = rolesList.map((role) => {
    return mapRoles[role];
  });
  
  return (
    <>
      <div className="profileHeaderContainer">
        <img
          src={
            userData.profilePicUrlList
              ? getImageUrl(userData.profilePicUrlList[0])
              : dummyUser
          }
          alt="userProfile"
          className="profileImg"
        />
        <img
          src={vectorProfile}
          alt="vectorProfile"
          className="profileVector"
        />
      </div>
      <div className="email-role-wrap">
        <p className="profile-email-text">{userData.email}</p>
        <div className="max-w-5xl flex flex-wrap">
          {roleValues.map((role, index) => (
            <p key={index} className="profile-role">
              {role}
            </p>
          ))}
        </div>
        {!userData.isPhoneVerified && (
          <button
            className="verifyPhoneBtnMain mt-2"
            onClick={() => setOpenVerify(true)}
          >
            <Smartphone size={15} />
            Verify Phone
          </button>
        )}
      </div>
      {openVerify && (
        <MobileVerify phone={userData.mobileNumber} setOpen={setOpenVerify} />
      )}
    </>
  );
};
export default ProfileHeader;
